/* ET - Cart drawer: "Voeg toe & bespaar" upsell + drawer extras.
   Originally built for TEST CART-007 (cart page vs cart drawer). The drawer
   won and the theme now runs natively with settings.cart_type == 'drawer',
   so the old test plumbing (Intelligems `et-cart-007` body class, the
   FoxThemeSettings page->drawer switch, the disabled drawer-opener handler)
   is gone. What remains is permanent drawer functionality:
   - the upsell slider (arrows/dots), the card variant dropdowns and their
     add-to-cart (markup rendered by snippets/et-cart-drawer-card.liquid,
     slider adapted from et-cart-new.js / CART_003);
   - Shopify recommendations as upsell source when Theme settings > Cart >
     ET - Cart drawer > "Upsell source" is set to Recommendations (cards
     fetched through sections/cart-drawer.liquid via
     routes.product_recommendations_url); the metafield source renders its
     cards server-side and never carries [data-et-cdr-reco], so the fetch
     is a no-op for it;
   - Trustpilot widget reload after drawer re-renders.
   All card handlers are delegated: cart-drawer.js / cart.js swap the
   drawer's innerHTML on every cart mutation.
   Loaded by snippets/cart-drawer.liquid. */
(function () {
  /* ------------------------------------------------------------------
     Upsell slider (adapted from assets/et-cart-new.js, CART_003)
     ------------------------------------------------------------------ */

  function sliderParts() {
    var root = document.querySelector('[data-et-cdr-slider]');
    if (!root) return null;
    return {
      root: root,
      track: root.querySelector('[data-et-cdr-track]'),
      prev: root.querySelector('[data-et-cdr-prev]'),
      next: root.querySelector('[data-et-cdr-next]'),
      dots: root.querySelector('[data-et-cdr-dots]'),
    };
  }

  function cardStep(track) {
    var cards = track.children;
    if (!cards.length) return track.clientWidth;
    if (cards.length > 1) {
      var step = cards[1].offsetLeft - cards[0].offsetLeft;
      if (step > 0) return step;
    }
    return cards[0].offsetWidth || track.clientWidth;
  }

  function scrollToCard(index) {
    var parts = sliderParts();
    if (!parts || !parts.track || isNaN(index)) return;
    parts.track.scrollTo({ left: cardStep(parts.track) * index, behavior: 'smooth' });
  }

  /* One window listener for the lifetime of the page; initSlider just swaps
     which sync function it drives, so re-renders never stack listeners. */
  var currentSliderSync = null;

  window.addEventListener('resize', function () {
    if (currentSliderSync) window.requestAnimationFrame(currentSliderSync);
  });

  /* Rebuilt after every drawer re-render: the elements are new, so the
     listeners added here never stack. */
  function initSlider() {
    currentSliderSync = null;

    var parts = sliderParts();
    if (!parts || !parts.track) return;

    var track = parts.track;
    var cards = track.children;

    if (parts.dots) {
      parts.dots.innerHTML = '';
      for (var i = 0; i < cards.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'et-cdr-dot';
        dot.setAttribute('data-et-cdr-dot', '');
        dot.dataset.cardIndex = String(i);
        dot.setAttribute('aria-label', String(i + 1) + ' / ' + cards.length);
        parts.dots.appendChild(dot);
      }
    }

    function sync() {
      /* Everything fits (one card, or the drawer is display:none): no nav. */
      var hasOverflow = track.scrollWidth - track.clientWidth > 1;
      parts.root.classList.toggle('is-static', !hasOverflow);

      var step = cardStep(track);
      var index = step > 0 ? Math.round(track.scrollLeft / step) : 0;
      index = Math.max(0, Math.min(index, cards.length - 1));

      if (parts.dots) {
        Array.prototype.forEach.call(parts.dots.children, function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (parts.prev) parts.prev.classList.toggle('is-disabled', track.scrollLeft <= 0);
      if (parts.next) parts.next.classList.toggle('is-disabled', track.scrollLeft >= maxScroll);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        sync();
      });
    });

    if (parts.prev) {
      parts.prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(track), behavior: 'smooth' });
      });
    }
    if (parts.next) {
      parts.next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(track), behavior: 'smooth' });
      });
    }

    currentSliderSync = sync;
    sync();
  }

  /* TrustBox iframes do not survive innerHTML swaps (same fix as
     et-cart-new.js): reload every widget inside the drawer. */
  function reloadTrustpilot() {
    var drawer = document.querySelector('#Drawer-Cart');
    if (!drawer || !window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return;

    drawer.querySelectorAll('.trustpilot-widget').forEach(function (widget) {
      try {
        window.Trustpilot.loadFromElement(widget, true);
      } catch (error) {
        /* The widget is decorative - never let it break the cart. */
      }
    });
  }

  /* ------------------------------------------------------------------
     Shopify recommendations as the upsell source (adapted from
     et-cart-new.js, CART_003). The track starts empty + hidden; cards
     come from sections/cart-drawer.liquid rendered through
     routes.product_recommendations_url.
     ------------------------------------------------------------------ */

  var recoGeneration = 0;

  function initRecommendations() {
    var slider = document.querySelector('[data-et-cdr-slider][data-et-cdr-reco]');
    if (!slider) return;

    var track = slider.querySelector('[data-et-cdr-track]');
    if (!track) return;

    var url = slider.dataset.recoUrl || '/recommendations/products';
    var intent = slider.dataset.recoIntent || 'complementary';
    var limit = parseInt(slider.dataset.recoLimit, 10) || 4;
    /* One request per unique product in the cart, capped to keep it cheap. */
    var productIds = (slider.dataset.recoProducts || '')
      .split(',')
      .filter(Boolean)
      .slice(0, 4);

    if (!productIds.length) {
      slider.hidden = true;
      return;
    }

    var generation = ++recoGeneration;

    var requests = productIds.map(function (productId) {
      var query =
        '?section_id=cart-drawer' +
        '&product_id=' + encodeURIComponent(productId) +
        '&limit=' + limit +
        '&intent=' + encodeURIComponent(intent);
      return fetch(url + query)
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .catch(function () {
          return '';
        });
    });

    Promise.all(requests).then(function (htmls) {
      /* A newer re-render owns the track now - drop this stale response. */
      if (generation !== recoGeneration) return;

      var liveSlider = document.querySelector('[data-et-cdr-slider][data-et-cdr-reco]');
      var liveTrack = liveSlider && liveSlider.querySelector('[data-et-cdr-track]');
      if (!liveSlider || !liveTrack) return;

      var seen = {};
      var cards = [];

      htmls.forEach(function (html) {
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        parsed.querySelectorAll('[data-et-cdr-card]').forEach(function (card) {
          var key = card.dataset.productId;
          if (!key || seen[key]) return;
          seen[key] = true;
          cards.push(card);
        });
      });

      cards = cards.slice(0, limit);

      if (!cards.length) {
        liveSlider.hidden = true;
        return;
      }

      liveTrack.innerHTML = '';
      cards.forEach(function (card) {
        liveTrack.appendChild(document.importNode(card, true));
      });
      liveSlider.hidden = false;
      initSlider();
    });
  }

  /* ------------------------------------------------------------------
     Stale-drawer watchdog. Kaching Bundles rewrites cart lines (new line
     keys, rebalanced quantities) AFTER our responses render, so the markup
     the shopper sees can lag behind the real cart; qty/remove clicks then
     target lines that no longer exist ("invalid id" errors). After every
     render, verify the open drawer against /cart.js and re-render it from
     fresh section HTML when they differ.
     ------------------------------------------------------------------ */
  var cartSyncTimer = null;

  function scheduleCartSync(delay) {
    clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(syncDrawerWithCart, delay || 1500);
  }

  function syncDrawerWithCart() {
    var drawer = document.querySelector('#Drawer-Cart');
    if (!drawer || typeof drawer.isOpen !== 'function' || !drawer.isOpen()) return;

    /* Never yank the markup out from under someone typing a quantity. */
    var active = document.activeElement;
    if (active && active.getAttribute && active.getAttribute('name') === 'updates[]') {
      scheduleCartSync();
      return;
    }

    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!drawer.isOpen()) return;

        var stale = drawer.querySelectorAll('.f-cart-item').length !== cart.items.length;

        if (!stale) {
          var qtyByKey = {};
          cart.items.forEach(function (item) { qtyByKey[item.key] = item.quantity; });
          drawer.querySelectorAll('[name="updates[]"][data-key]').forEach(function (input) {
            if (!(input.dataset.key in qtyByKey) || parseInt(input.value, 10) !== qtyByKey[input.dataset.key]) stale = true;
          });
        }

        if (!stale) {
          /* Keep a gentle poll going while the drawer stays open, so a late
             background rebalance still gets picked up. Stops when closed. */
          scheduleCartSync(3000);
          return;
        }

        return fetch(window.location.pathname + '?sections=cart-drawer')
          .then(function (response) { return response.json(); })
          .then(function (sections) {
            var cartDrawer = document.querySelector('cart-drawer');
            if (!cartDrawer || !sections || !sections['cart-drawer']) return;
            cartDrawer.renderContents({ sections: sections });
            cartDrawer.classList.toggle('is-empty', cart.item_count === 0);
            /* ON_CART_UPDATED re-enters onDrawerRendered -> scheduleCartSync,
               so this converges once the DOM matches the cart. */
            if (window.FoxThemeEvents) window.FoxThemeEvents.emit('ON_CART_UPDATED', cart);
          });
      })
      .catch(function () {});
  }

  /* Runs after every drawer re-render (and on open / page load). */
  function onDrawerRendered() {
    window.requestAnimationFrame(function () {
      initSlider();
      reloadTrustpilot();
      initRecommendations();
      scheduleCartSync();
    });
  }

  /* ------------------------------------------------------------------
     Upsell card interactions (delegated - survive innerHTML swaps)
     ------------------------------------------------------------------ */

  function onVariantChange(select) {
    var card = select.closest('[data-et-cdr-card]');
    var option = select.options[select.selectedIndex];
    if (!card || !option) return;

    var addButton = card.querySelector('[data-et-cdr-add]');
    if (addButton) addButton.dataset.variantId = select.value;

    var price = card.querySelector('[data-card-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;

    var compare = card.querySelector('[data-card-compare]');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }

    var badge = card.querySelector('[data-card-badge]');
    if (badge) {
      var pct = parseInt(option.dataset.pct, 10) || 0;
      badge.textContent = '-' + pct + '%';
      badge.hidden = pct <= 0;
    }

    var image = card.querySelector('[data-card-image]');
    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.removeAttribute('srcset');
    }
  }

  function addUpsell(button) {
    var variantId = button.dataset.variantId;
    if (!variantId || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');

    var cartDrawer = document.querySelector('cart-drawer');
    var settings = window.FoxThemeSettings || {};
    var routes = settings.routes || {};

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (cartDrawer) {
      body.append(
        'sections',
        cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      body.append('sections_url', window.location.pathname);
    }

    fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: body,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          var errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = response.description || response.message || '';
          return;
        }
        /* The theme re-renders the drawer items, footer and cart count off
           this event (cart-drawer.js / cart.js); the subscriber below then
           rebuilds the slider on the fresh markup. */
        if (window.FoxThemeEvents) window.FoxThemeEvents.emit('ON_ITEM_ADDED', response);
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('change', function (event) {
    if (!(event.target instanceof Element)) return;
    var select = event.target.closest('[data-et-cdr-variant]');
    if (select) onVariantChange(select);
  });

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var addButton = event.target.closest('[data-et-cdr-add]');
    if (addButton) {
      event.preventDefault();
      addUpsell(addButton);
      return;
    }

    var dot = event.target.closest('[data-et-cdr-dot]');
    if (dot) scrollToCard(parseInt(dot.dataset.cardIndex, 10));
  });

  if (window.FoxThemeEvents) {
    window.FoxThemeEvents.subscribe('ON_ITEM_ADDED', onDrawerRendered);
    window.FoxThemeEvents.subscribe('ON_CART_UPDATED', onDrawerRendered);
  }

  /* The slider measures 0 while the drawer is closed off-screen or hidden,
     so re-sync whenever the drawer opens ('open' is dispatched by the
     theme's drawer-component in global.js). */
  var drawer = document.querySelector('#Drawer-Cart');
  if (drawer) drawer.addEventListener('open', onDrawerRendered);

  onDrawerRendered();
})();
